__turbopack_context__.v({
  "answer": "replace-systems-module__z6Kh2G__answer",
  "body": "replace-systems-module__z6Kh2G__body",
  "brandLtr": "replace-systems-module__z6Kh2G__brandLtr",
  "card": "replace-systems-module__z6Kh2G__card",
  "inner": "replace-systems-module__z6Kh2G__inner",
  "pills": "replace-systems-module__z6Kh2G__pills",
  "question": "replace-systems-module__z6Kh2G__question",
  "section": "replace-systems-module__z6Kh2G__section",
});
